module.exports = __webpack_public_path__ + "static/img/1_0007.2194c0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0007.jpg
// module id = VObn
// module chunks = 0